<template>
  <div class="card">
    <input
      id="requestFaqFileInput"
      ref="file"
      type="file"
      style="display: none"
      @change="setPhoto"
    >
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center">
        <h4>{{ $t('requestFaq.sualCavab') }}</h4>
        <div v-if="canParticipate">
          <button
            v-if="!faqAskFormOpen"
            class="btn btn-sm btn-light-primary"
            @click.prevent="faqAskFormOpen= true"
          >
            {{ isMyRequest ? "+ Tədarükçülərə müraciət et" : $t('requestFaq.yeniSualVer') }}
          </button>
        </div>
      </div>
      <hr>

      <div
        v-if="canParticipate && faqAskFormOpen"
        class="ask-question-form"
      >
        <form @submit.prevent="addFaqQuestion">
          <div class="form-group">
            <input
              v-model="faqAskQuestion"
              class="form-control"
              type="text"
              required
              :placeholder="$t('requestFaq.sualMtniniDaxilEdin')"
            >
          </div>

          <div v-if="canOfferStatus === 'own_request'">
            <div
              v-if="faqAskFile"
              class="file-attachment mb-2"
            >
              <div class="d-flex justify-content-between align-items-center w-100">
                <a
                  :href="getPhoto(faqAskFile, '')"
                  target="_blank"
                >
                  <i
                    v-if="isPhoto(faqAskFile)"
                    class="fa fa-fw fa-photo"
                  />
                  <i
                    v-else
                    class="fa fa-fw fa-paperclip"
                  />
                  {{ (faqAskFile || '').split('/').pop() }}
                </a>
                <a
                  class="cursor-pointer text-dark"
                  @click.prevent="faqAskFile=''"
                >
                  <i class="fa fa-times" />
                </a>
              </div>
            </div>
            <div
              v-else
              class="mb-2"
            >
              <button
                type="button"
                class="btn btn-sm btn-light-primary"
                @click="selectAskFile"
              >
                <i class="fa fa-paperclip" /> {{ $t('requestFaq.faylLavEt') }}
              </button>
            </div>
          </div>

          <div class="form-actions">
            <button
              class="btn btn-sm btn-light-primary"
              type="submit"
            >
              {{ $t('body.gndr') }}
            </button>
            <button
              class="btn btn-sm btn-light-dark"
              type="button"
              @click="faqAskFormOpen=false"
            >
              {{ $t('companyProfile.lvEt2') }}
            </button>
          </div>
        </form>
        <hr>
      </div>


      <div
        v-if="requestFaq.length<1"
        class="alert alert-danger"
      >
        <span v-if="request.requestType === 'AUC'">{{ $t('requestFaq.hrraclaBalSualYoxdur') }}</span>
        <span v-else-if="request.requestType === 'REV'">{{ $t('requestFaq.ksHrraclaBalSualYoxdur') }}</span>
        <span v-else>{{ $t('requestFaq.soruIlBalSualYoxdur') }}</span>
      </div>

      <div v-else>
        <div class="alert alert-primary mb-3">
          {{ $t('requestFaq.suallarVCavablarBtnItiraklaraGrnrMvzudanKnarSualTk') }}
        </div>
        <div
          v-for="(question,i) in requestFaq"
          :key="question.id"
          class="faq-item"
        >
          <div class="faq-header">
            <div class="faq-badge-container">
              <span class="badge badge-success">
                {{
                  (requestCreateUser && requestCreateUser.id === question.requestUser.userId) ? $t("request.soruMllifi") :
                  $t("requestParticipants.itirak") + "# " + question.requestUser.userOrder
                }}</span>
              <button
                v-if="requestCreateUser && requestCreateUser.id=== user.id"
                class="btn btn-sm btn-icon ml-1"
                @click="showUserInfo(question.requestUser)"
              >
                <i class="fa fa-info-circle" />
              </button>
              <br>
              <span
                v-if="requestUser && requestUser.userOrder === question.requestUser.userOrder "
                class="small"
              >
                {{ $t('aucPrices.buSizsiniz') }}
              </span>
            </div>
            <div class="faq-content">
              <div class="question-container">
                <div
                  v-if="question.status !== 'REJECTED'"
                  class="question-text"
                >
                  {{ question.question }}
                  <div
                    v-if="question.file"
                    class="file-attachment mt-2"
                  >
                    <a
                      :href="getPhoto(question.file, '')"
                      target="_blank"
                    >
                      <i
                        v-if="isPhoto(question.file)"
                        class="fa fa-fw fa-photo"
                      />
                      <i
                        v-else
                        class="fa fa-fw fa-paperclip"
                      />
                      {{ (question.file || '').split('/').pop() }}
                    </a>
                  </div>

                  <template v-if="question.status=== 'NEW'">
                    <div
                      v-if="isMyRequest && request.status ==='ACTIVE' && (canOfferStatus !== 'own_request' || requestCreateUser.id !== question.requestUser.userId)"
                      class="question-status"
                    >
                      <a
                        v-if="answering.indexOf(question.id) === -1"
                        href="#"
                        class="text-primary"
                        @click.prevent="answering.push(question.id)"
                      >
                        <u>{{ $t('requestFaq.cavabVer') }}</u>
                      </a>
                    </div>
                    <div
                      v-if="canOfferStatus === 'own_request' && requestCreateUser && requestCreateUser.id === question.requestUser.userId"
                      class="question-status"
                    >
                      <div class="text-warning">
                        {{ $t('requestFaq.buSualCavablanmaybOwnRequest') }}
                      </div>
                    </div>
                    <div
                      v-else
                      class="question-status"
                    >
                      <div
                        v-if="!(requestCreateUser && requestCreateUser.id === question.requestUser.userId)"
                        class="text-warning"
                      >
                        {{ $t('requestFaq.buSualCavablanmayb') }}
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  v-else
                  class="text-danger question-text"
                >
                  {{ $t('requestFaq.sualBloklanb') }}
                </div>
              </div>

              <div v-if="question.status === 'ANSWERED'">
                <div class="answer-header">
                  <span class="badge badge-primary">{{ $t('request.soruMllifi') }}</span>
                </div>
                <div
                  v-if="!editingAnswers[i]"
                  class="answer-container"
                >
                  <div class="answer-text">
                    {{ question.answer }}
                  </div>
                  <div
                    v-if="isMyRequest"
                    class="answer-actions"
                  >
                    <button
                      class="btn btn-sm btn-light-secondary"
                      @click="startEdit(i)"
                    >
                      Dəyiş
                    </button>
                  </div>

                  <div
                    v-if="question.file"
                    class="file-attachment"
                  >
                    <a
                      :href="getPhoto(question.file, '')"
                      target="_blank"
                    >
                      <i
                        v-if="isPhoto(question.file)"
                        class="fa fa-fw fa-photo"
                      />
                      <i
                        v-else
                        class="fa fa-fw fa-paperclip"
                      />
                      {{ (question.file || '').split('/').pop() }}
                    </a>
                  </div>
                </div>
                <div
                  v-else
                  class="answer-form"
                >
                  <form @submit.prevent="submitEdit(i)">
                    <textarea
                      v-model="editingAnswers[i]"
                      class="form-control"
                      required
                      :placeholder="$t('requestFaq.cavabDaxilEdin')"
                    />
                    <!-- file preview or picker -->
                    <div
                      v-if="editingFiles[i]"
                      class="file-attachment"
                    >
                      <a
                        :href="getPhoto(editingFiles[i], '')"
                        target="_blank"
                      >
                        {{ editingFiles[i].split('/').pop() }}
                      </a>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger"
                        @click="clearEditingFile(i)"
                      >
                        ×
                      </button>
                    </div>
                    <div
                      v-else
                      class="mb-2"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        @click="selectEditPhoto(i)"
                      >
                        <i class="fa fa-paperclip" /> {{ $t('requestFaq.faylLavEt') }}
                      </button>
                    </div>
                    <div class="answer-form-actions">
                      <button
                        type="submit"
                        class="btn btn-sm btn-primary"
                      >
                        {{ $t('requestFaq.cavabla') }}
                      </button>
                      <button
                        type="button"
                        class="btn btn-sm btn-light"
                        @click="cancelEdit(i)"
                      >
                        {{ $t('companyProfile.lvEt2') }}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
              <div v-else-if="question.status === 'REJECTED'">
                <div class="answer-header">
                  <span class="badge badge-primary">{{ $t('request.soruMllifi') }}</span>
                </div>

                <div class="rejected-message">
                  <span v-if="question.answeredBy==='admin'">
                    <strong v-if="question.requestUser.userStatus==='BLOCKED'">{{
                      $t('requestFaq.itirakAdminTrfindnBloklanb')
                    }}</strong>
                    <strong v-else>{{ $t('requestFaq.sualAdminTrfindnBloklanb') }}</strong>
                    <em>{{ question.answer }}</em>
                  </span>
                  <span v-else>
                    <strong v-if="question.requestUser.userStatus==='BLOCKED'">{{
                      $t('requestFaq.itirakBloklanb')
                    }}</strong>
                    <strong v-else>{{ $t('requestFaq.sualBloklanb') }}</strong>
                    <span>{{ question.answer }}</span>
                  </span>
                </div>
                <div
                  v-if="isMyRequest && question.answeredBy!=='admin'"
                  class="answer-actions"
                >
                  <button
                    v-if="question.requestUser.userStatus==='BLOCKED'"
                    class="btn btn-sm btn-light-danger"
                    type="button"
                    @click="unBlockRequestUser(question)"
                  >
                    <span>{{ $t('requestFaq.itiraknBlokdanXar') }}</span>
                  </button>
                  <button
                    v-else
                    class="btn btn-sm btn-light-warning"
                    type="button"
                    @click="unRejectFaqQuestion(question)"
                  >
                    <span>{{ $t('requestFaq.sualBlokdanXar') }}</span>
                  </button>
                </div>
              </div>
              <div v-else>
                <div
                  v-if="isMyRequest && request.status ==='ACTIVE' && answering.indexOf(question.id)>-1"
                  class="answer-form"
                >
                  <form @submit.prevent="answerFaqQuestion(i)">
                    <textarea
                      v-model="faqQuestionAnswers[i]"
                      class="form-control"
                      type="text"
                      required
                      :placeholder="$t('requestFaq.cavabDaxilEdin')"
                    />

                    <div
                      v-if="faqQuestionFiles[i]"
                      class="file-attachment"
                    >
                      <div class="d-flex justify-content-between align-items-center w-100">
                        <a
                          :href="getPhoto(faqQuestionFiles[i], '')"
                          target="_blank"
                        >
                          <i
                            v-if="isPhoto(faqQuestionFiles[i])"
                            class="fa fa-fw fa-photo"
                          />
                          <i
                            v-else
                            class="fa fa-fw fa-paperclip"
                          />
                          {{ (faqQuestionFiles[i] || '').split('/').pop() }}
                        </a>
                        <a
                          class="cursor-pointer text-dark"
                          @click.prevent="faqQuestionFiles[i]=''"
                        >
                          <i class="fa fa-times" />
                        </a>
                      </div>
                    </div>
                    <div
                      v-else
                      class="mb-3"
                    >
                      <button
                        type="button"
                        class="btn btn-sm btn-light-primary"
                        @click="selectPhoto(i)"
                      >
                        <i class="fa fa-paperclip" /> {{ $t('requestFaq.faylLavEt') }}
                      </button>
                    </div>

                    <div class="answer-form-actions">
                      <button
                        class="btn btn-sm btn-primary"
                        type="submit"
                      >
                        <span>{{ $t('requestFaq.cavabla') }}</span>
                      </button>

                      <button
                        class="btn btn-sm btn-light"
                        type="button"
                        @click.prevent="cancelAnswering(question.id)"
                      >
                        <span>{{ $t('companyProfile.lvEt2') }}</span>
                      </button>

                      <button
                        class="btn btn-sm btn-light-danger"
                        type="button"
                        @click="blockRequestUser(question)"
                      >
                        <span>{{ $t('requestFaq.itiraknBlokla') }}</span>
                      </button>
                      <button
                        class="btn btn-sm btn-light-warning"
                        type="button"
                        @click="rejectFaqQuestion(question)"
                      >
                        <span>{{ $t('requestFaq.sualLvEt') }}</span>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      id="modal-user-info"
      :title="$t('request.soruMllifi')"
      ok-only
      ok-variant="primary"
      :ok-title="$t('body.bala')"
      class="theme-modal"
    >
      <div v-if="selectedUser">
        <div class="user-info-item">
          <strong>{{ $t('body.fullName') }}:</strong> {{ selectedUser.fullName }}
        </div>
        <div class="user-info-item">
          <strong>{{ $t('body.phone') }}:</strong> {{ selectedUser.phone }}
        </div>
      </div>
    </b-modal>
  </div>

  <!-- User Info Modal -->
</template>
<script>
import {
  answerFaqQuestion,
  askFaqQuestion,
  blockRequestUser,
  editAnswer,
  getRequestFaq,
  rejectFaqQuestion,
  unBlockRequestUser,
  upload
} from "@/repositories/GeneralDataRepository";
import {mapState} from "vuex";
import {getPhoto} from "@/repositories/Utils";
import {editFaqQuestion} from "@/repositories/VendorManagementRepository";

export default {
  name: 'RequestFAQ',
  props: {
    canOfferStatus: {},
    isMyRequest: {},
    canParticipate: {},
    request: {},
    requestUser: {},
  },
  data() {

    return {
      requestCreateUser: null,
      editingAnswers: {},      // keyed by question index or id
      editingFiles: {},
      editingFileIndex: -1,
      updateTimer: null,
      requestFaq: [],
      faqAskFormOpen: false,

      faqAskQuestion: '',
      faqAskFile: '',
      faqQuestionAnswers: {},
      faqQuestionFiles: {},
      fileIndex: -1,

      answering: [],
      selectedUser: null,
    }

  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
      company: state => state.auth.company,
    }),


  },

  mounted() {
    this.loadFaqList();
    this.updateTimer = setInterval(() => {
      this.loadFaqList();
    }, 3000);
  },

  beforeDestroy() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer);
    }
  },

  methods: {
    startEdit(index) {
      const q = this.requestFaq[index];
      // prefill the text and file
      this.$set(this.editingAnswers, index, q.answer);
      this.$set(this.editingFiles, index, q.file || '');
    },

    cancelEdit(index) {
      this.$delete(this.editingAnswers, index);
      this.$delete(this.editingFiles, index);
    },

    submitEdit(index) {
      const id = this.requestFaq[index].id;
      const answer = this.editingAnswers[index];
      const file = this.editingFiles[index] || '';
      editAnswer(this.token, id, answer, file)
          .then(data => {
            if (data.code === 200) {
              this.loadFaqList();
              this.cancelEdit(index);
            } else {
              this.$swal({title: `Xəta ${data.code}`, text: data.message, icon: 'error'});
            }
          });
    },

    clearEditingFile(index) {
      this.$set(this.editingFiles, index, '');
    },

    selectEditPhoto(index) {
      this.editingFileIndex = index;
      // reuse the same hidden <input type="file" id="requestFaqFileInput">
      document.getElementById('requestFaqFileInput').click();
    },
    addFaqQuestion() {
      askFaqQuestion(this.token, this.request.id, this.faqAskQuestion, this.faqAskFile).then(data => {
        if (data.code === 200) {
          this.loadFaqList();
          this.faqAskQuestion = '';
          this.faqAskFile = '';
          this.faqAskFormOpen = false;
        } else if (data.code === 403) {

          let message = data.message;
          if (data.errorCode === 'you_blocked_but_company_can_join') {
            message = this.$t("sznSualVrmrImknnzBlklnb");
          } else if (data.errorCode === 'you_blocked') {
            message = this.$t("aucPrices.youBlocked");
          }

          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: message,
            icon: 'error'
          })
        } else if (data.code === 409) {

          let message = data.message;

          if (data.errorCode === 'company_already_participating') {
            message = this.$t("aucPrices.fromYourCompany") + data.user + this.$t("aucPrices.fromYourCompany");
          } else if (data.errorCode === 'user_already_participating') {
            message = this.$t("aucPrices.you") + data.company + this.$t("aucPrices.istirakEdirsiz");
          }

          this.$swal({
            title: `Diqqət (${data.code})`,
            text: `${message}`,
            icon: 'error'
          })
        } else if (data.code === 425 && this.canOfferStatus === 'own_request') {
          // Handle the 425 limit exceeded error for authors
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("requestFaq.limitExceeded"),
            icon: 'warning'
          })
        } else {
          this.$swal({
            title: `Xəta ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },
    answerFaqQuestion(index) {

      answerFaqQuestion(this.token, this.requestFaq[index]['id'], this.faqQuestionAnswers[index], (this.faqQuestionFiles[index] || '')).then(data => {
        if (data.code === 200) {
          this.loadFaqList();
        } else {
          this.$swal({
            title: `Xəta ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      });
    },
    editAnswerFaqQuestion(index) {
      editFaqQuestion(this.token, this.requestFaq[index]['id'], this.faqQuestionAnswers[index], (this.faqQuestionFiles[index] || '')).then(data => {
        if (data.code === 200) {
          this.loadFaqList();
        } else {
          this.$swal({
            title: `Xəta ${data.code}`,
            text: `${data.message}`,
            icon: 'error'
          })
        }
      })
    },
    rejectFaqQuestion(question) {
      this.$swal({
        title: this.$t("blklmSbbDxlEdin"),
        icon: 'warning',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("blkla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          rejectFaqQuestion(this.token, question.id, result.value).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },
    unRejectFaqQuestion(question) {
      this.$swal({
        title: this.$t("slCvblyn"),
        icon: 'warning',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("sliCvbla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          answerFaqQuestion(this.token, question.id, result.value, '').then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Xəta ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },
    blockRequestUser(question) {
      this.$swal({
        title: this.$t("istrkcnBlklmqSbb"),
        icon: 'warning',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("blkla"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          blockRequestUser(this.token, question.id, result.value).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Xəta ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },

    unBlockRequestUser(question) {
      this.$swal({
        title: this.$t("istrkcnBlkdnCxrmq"),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: this.$t("blkdnCxr"),
        cancelButtonText: this.$t("companyProfile.lvEt2")
      }).then((result) => {
        if (result.value) {
          unBlockRequestUser(this.token, question.id).then(data => {
            if (data.code === 200) {
              this.loadFaqList();
            } else {
              this.$swal({
                title: `Error ${data.code}`,
                text: `${data.message}`,
                icon: 'error'
              })
            }
          });
        }
      });
    },

    loadFaqList() {
      getRequestFaq(this.token, this.request.id).then(list => {
        this.requestFaq = list.faq;
        this.requestCreateUser = list.user;
      })
    },


    selectPhoto(index) {
      this.fileIndex = index;
      window.document.getElementById('requestFaqFileInput').click();
    },

    selectAskFile() {
      this.fileIndex = -2; // Special flag to indicate we're selecting a file for asking a question
      window.document.getElementById('requestFaqFileInput').click();
    },

    setPhoto() {
      let currentFile = this.$refs.file.files[0];

      if (window.File && window.FileReader && window.FileList && window.Blob) {

        upload(this.token, 'faqAnswer', currentFile, event => {
          this.uploadProgress = Math.round((100 * event.loaded) / event.total);
        })
            .then(response => {
              this.uploadProgress = 100;
              if (response.data.code === 200) {
                if (this.editingFileIndex > -1) {
                  this.$set(this.editingFiles, this.editingFileIndex, response.data.path);
                } else if (this.fileIndex === -2) {
                  // For asking a question
                  this.faqAskFile = response.data.path;
                } else {
                  this.$set(this.faqQuestionFiles, this.fileIndex, response.data.path);
                }
              } else {
                this.$swal({
                  title: `Error ${response.data.code}`,
                  text: `${response.data.message}`,
                  icon: 'error'
                })
              }
            })
            .catch((e) => {

              this.progress = 0;
              this.$swal({
                title: `Error`,
                text: this.$t("cldNotUploadFile") + e,
                icon: 'error'
              })
            });

      } else {
        this.$swal({
          title: `Error`,
          text: this.$t("photoUploadNotSpprtdBrowser"),
          icon: 'error'
        })
      }
    },
    isPhoto(path) {
      return ['jpg', 'png', 'gif', 'jpeg'].indexOf(path.toLowerCase().split('.').pop()) > -1;
    },
    getPhoto(path, size, defaultPhoto) {
      return getPhoto(path, size, defaultPhoto);
    },

    cancelAnswering(id) {
      this.answering = this.answering.filter(i => i !== id);
    },

    showUserInfo(user) {
      this.selectedUser = user;
      this.$bvModal.show('modal-user-info');
    }
  }
}
</script>
<style scoped>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}

/* Modern FAQ Styling */
.card {
  border: none;
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.card-body {
  padding: 25px;
}

h4 {
  font-size: 1.4rem;
  font-weight: 600;
  color: #333;
  margin: 0;
}

hr {
  border-color: #f0f0f0;
  margin: 20px 0;
}

/* Form styling */
.form-control {
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  padding: 12px 15px;
  transition: all 0.2s ease;
}

.form-control:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

/* Button styling */
.btn {
  border-radius: 6px;
  font-weight: 500;
  padding: 8px 16px;
  transition: all 0.2s ease;
}

.btn-light-primary {
  background-color: rgba(0, 123, 255, 0.1);
  color: #007bff;
  border: none;
}

.btn-light-primary:hover {
  background-color: rgba(0, 123, 255, 0.2);
}

.btn-light-dark {
  background-color: rgba(52, 58, 64, 0.1);
  color: #343a40;
  border: none;
}

.btn-light-dark:hover {
  background-color: rgba(52, 58, 64, 0.2);
}

.btn-light-secondary {
  background-color: rgba(108, 117, 125, 0.1);
  color: #6c757d;
  border: none;
}

.btn-light-secondary:hover {
  background-color: rgba(108, 117, 125, 0.2);
}

.btn-light-warning {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
  border: none;
}

.btn-light-warning:hover {
  background-color: rgba(255, 193, 7, 0.2);
}

.btn-light-danger {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: none;
}

.btn-light-danger:hover {
  background-color: rgba(220, 53, 69, 0.2);
}

/* Alert styling */
.alert {
  border-radius: 8px;
  padding: 15px;
  border: none;
  margin-bottom: 20px;
}

.alert-danger {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.alert-primary {
  background-color: rgba(0, 123, 255, 0.1);
  color: #007bff;
}

/* Badge styling */
.badge {
  padding: 5px 10px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 0.75rem;
}

.badge-success {
  background-color: #28a745;
  color: white;
}

.badge-primary {
  background-color: #007bff;
  color: white;
}

/* FAQ Item styling */
.faq-item {
  margin-bottom: 25px;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.faq-item:hover {
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
}

.faq-header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
}

.faq-badge-container {
  margin-right: 15px;
}

.faq-content {
  flex: 1;
}

.question-container {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
  margin-bottom: 15px;
  position: relative;
  border-left: 4px solid #28a745;
}

.question-text {
  font-size: 1rem;
  color: #333;
  line-height: 1.5;
}

.question-status {
  margin-top: 10px;
  font-size: 0.9rem;
  color: #6c757d;
}

.answer-container {
  background-color: #f0f4f8;
  border-radius: 10px;
  padding: 15px;
  margin-top: 10px;
  margin-bottom: 15px;
  position: relative;
  border-left: 4px solid #007bff;
}

.answer-header {
  margin-bottom: 10px;
}

.answer-text {
  font-size: 1rem;
  color: #333;
  line-height: 1.5;
}

.answer-actions {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.file-attachment {
  display: flex;
  align-items: center;
  background-color: rgba(0, 123, 255, 0.05);
  border: 1px solid rgba(0, 123, 255, 0.1);
  border-radius: 6px;
  padding: 8px 12px;
  margin: 10px 0;
  transition: all 0.2s ease;
}

.file-attachment:hover {
  background-color: rgba(0, 123, 255, 0.1);
}

.file-attachment i {
  margin-right: 8px;
  color: #6c757d;
}

.file-attachment a {
  color: #007bff;
  text-decoration: none;
}

.file-attachment a:hover {
  text-decoration: underline;
}

.rejected-message {
  background-color: rgba(220, 53, 69, 0.1);
  border-radius: 8px;
  padding: 15px;
  margin-top: 10px;
}

.rejected-message strong {
  display: block;
  margin-bottom: 5px;
  color: #dc3545;
}

.rejected-message em {
  font-style: italic;
  color: #6c757d;
}

/* Answer form styling */
.answer-form {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 15px;
  margin-top: 15px;
}

.answer-form textarea {
  width: 100%;
  border-radius: 6px;
  padding: 12px;
  margin-bottom: 15px;
  border: 1px solid #e0e0e0;
}

.answer-form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 15px;
}

/* Ask Question Form styling */
.ask-question-form {
  background-color: #f8f9fa;
  border-radius: 10px;
  padding: 20px;
  margin-bottom: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.ask-question-form:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.form-group {
  margin-bottom: 15px;
}

.form-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-bottom: 15px;
}

/* Responsive adjustments */
/* User Info Modal Styling */
.user-info-item {
  margin-bottom: 10px;
  padding: 8px;
  border-radius: 6px;
  background-color: #f8f9fa;
}

.user-info-item strong {
  font-weight: 600;
  color: #333;
}

.btn-icon {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1.5;
  border-radius: 0.2rem;
  color: #007bff;
  background-color: transparent;
  border: none;
}

.btn-icon:hover {
  color: #0056b3;
  background-color: rgba(0, 123, 255, 0.1);
}

@media (max-width: 768px) {
  .card-body {
    padding: 15px;
  }

  h4 {
    font-size: 1.2rem;
  }

  .question-container, .answer-container {
    padding: 12px;
  }

  .faq-badge-container {
    margin-right: 10px;
  }

  .badge {
    font-size: 0.7rem;
    padding: 4px 8px;
  }

  .btn {
    padding: 6px 12px;
    font-size: 0.85rem;
  }
}
</style>
